export default __webpack_public_path__ + "static/media/legend-dots.ffd7a282.svg";